import type { ButtonProps} from '@Components/button';
import {Button, ButtonType, ButtonSize} from '@Components/button';
import {getButtonPropsWithDefaultType} from '@Utils/button.util';

export type PanelFooterPrimaryDefaultActionProps = ButtonProps & {
  className?: string;
};

export function PanelFooterPrimaryDefaultAction({className = '', ...props}: PanelFooterPrimaryDefaultActionProps) {
  return <Button size={ButtonSize.LARGE} {...getButtonPropsWithDefaultType(props, ButtonType.PRIMARY)} customClasses={className} />;
}
